import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Grid, Image, Text, Divider
} from 'components/ui';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';
import { PAYMENT_LOGO_SIZE } from 'constants/Checkout';
import dateUtils from 'utils/Date';
import helperUtils, { formatCurrencyAmount } from 'utils/Helpers';

const AccountCredit = ({
    locales, storeCredit, withCheckbox = true, isEditView = false, ...props
}) => {
    // Use amount for the first line (full available credit for this specific AC)
    // Use appliedAmount for the second line (applied to current order)
    const fullAmount = storeCredit.amount ?? storeCredit.amount;
    const appliedAmount = storeCredit.appliedAmount ?? storeCredit.amount;

    const formattedRemainingAmount = helperUtils.hideZeroCents(formatCurrencyAmount(fullAmount));
    const formattedAppliedAmount = helperUtils.hideZeroCents(appliedAmount);

    const appliedText = storeCredit.expirationDate
        ? `${formattedAppliedAmount} ${locales.accountCreditApplied} \u2022 ${locales.expires} ${dateUtils.getCreditCardExpiry(storeCredit.expirationDate)}`
        : `${formattedAppliedAmount} ${locales.accountCreditApplied}`;

    const grid = (
        <>
            <Box
                paddingTop={isEditView ? 4 : 0}
                paddingBottom={isEditView ? 4 : 0}
            >
                <Grid
                    columns='auto 1fr'
                    gap={3}
                    alignItems='center'
                    lineHeight='tight'
                    {...props}
                >
                    <Image
                        display='block'
                        src='/img/ufe/payments/accountCredit.svg'
                        alt={locales.accountCreditAltText}
                        {...PAYMENT_LOGO_SIZE}
                    />
                    <div>
                        <Text is='p'>
                            {formattedRemainingAmount} {locales.storeCreditApplied}
                        </Text>
                        <Text
                            data-at={Sephora.debug.dataAt('ac_applied_label')}
                            fontSize='sm'
                            children={appliedText}
                        />
                    </div>
                </Grid>
            </Box>
            {isEditView && <Divider />}
        </>
    );

    if (!withCheckbox) {
        return grid;
    }

    return (
        <>
            <Box py={4}>
                <Checkbox
                    paddingY={0}
                    checked={true}
                    disabled={true}
                    alignItems='center'
                >
                    {grid}
                </Checkbox>
            </Box>
            <Divider />
        </>
    );
};

export default wrapFunctionalComponent(AccountCredit, 'AccountCredit');
